import { otherLocales } from './other-locales';
import { pwaLocales } from './pwa-locales';

export const allLocales = [...pwaLocales, ...otherLocales];
export type AnyLocale = typeof allLocales[number];
